<section>
    <header class="row page-header">
        <div class="col-sm-12">
            <sp-breadcrumbs>
                <sp-breadcrumb [text]="'Users'" [routerLink]="'../'"></sp-breadcrumb>
            </sp-breadcrumbs>

            <div class="row">
                <div class="col-sm-12">
                    <a class="btn-back" [routerLink]="['../']"></a>
                    <h2 class="title">{{ userName }}</h2>
                </div>
            </div>
        </div>
    </header>

    <main>
        <sp-admin-user-edit 
            *ngIf="adminUser$ | async"
            [user]="adminUser$ | async"
            [userProfile]="userProfile$ | async"
            (cancel)="onCancel()"
            (save)="onSave($event)">
        </sp-admin-user-edit>
    </main>
</section>